import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";
import { getCurrentLanguage } from "~/utils/language";

const initPromise = i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    lng: getCurrentLanguage(),
    fallbackLng: "eng",
    supportedLngs: ["eng", "fr", "es"],

    // Where to load translation files from
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },

    // Start with just 'translation' namespace
    ns: ["translation"],
    defaultNS: "translation",

    // Verbose i18next logs (missing keys, events) — opt in; dev mode alone was too noisy
    debug: process.env.REACT_APP_I18N_DEBUG === "true",

    interpolation: {
      escapeValue: false, // React already escapes by default
    },

    react: {
      useSuspense: false,
    },
  });

export default i18n;
export { initPromise };
